import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import React from 'react';
import classes from './Checkboxes.module.scss';

function Checkboxes(props: ComponentProps, ref: any) {
	const name = useMemo(() => window.crypto.randomUUID(), []);
	const [options, setOptions] = useState(props.options || []);
	const [selectedValues, setSelectedValues] = useState(props.selectedValues || []);
	const classNames = [classes.Checkboxes];
	if (props.className) {
		classNames.push(props.className);
	}

	if (props.horizontal) {
		classNames.push(classes.horizontal);
	}

	function onChange(value: string, e: React.FormEvent) {
		const target = e.target as HTMLInputElement;
		const checked = target.checked;
		const _selectedValues = [...selectedValues];
		if (checked) {
			_selectedValues.push(value);
		} else {
			_selectedValues.splice(_selectedValues.indexOf(value), 1);
		}
		setSelectedValues(_selectedValues);
		props.onChange && props.onChange(value, checked, _selectedValues);
	}

	function getValues() {
		return selectedValues;
	}

	function setValues(values: string[]) {
		setSelectedValues(values);
	}

	useEffect(() => {
		setValues(props.selectedValues || []);
	}, [props.selectedValues]);

	useEffect(() => {
		setOptions(props.options || []);
	}, [props.options]);

	useImperativeHandle(ref, () => ({
		getValues,
		setValues,
	}));

	return (
		<div className={classNames.join(' ')}>
			{options.map((option: Option) => {
				return (
					<div className={classes.radioButtonContainer} key={option.value}>
						<input
							type="checkbox"
							value={option.value}
							id={`checkbox-${name}-${option.value}`}
							name={name}
							checked={selectedValues.includes(option.value)}
							required={props.required}
							onChange={(e) => onChange(option.value, e)}
							disabled={props.disabled ? true : false}
						/>
						<label
							htmlFor={`checkbox-${name}-${option.value}`}
							className={props.required && selectedValues.length === 0 ? classes.required : undefined}
						>
							{option.label}
						</label>
					</div>
				);
			})}
		</div>
	);
}
interface ComponentProps {
	options: Option[];
	selectedValues?: string[];
	className?: string;
	horizontal?: boolean;
	onChange?: Function;
	required?: boolean;
	disabled?: boolean;
}

type Option = {
	label: string;
	value: string;
	selected?: boolean;
};

export default forwardRef(Checkboxes);
